module.exports = "<div class=\"ui-dialog-scroll\">\n  <pdf-viewer [src]=\"pdfSrc\"></pdf-viewer>\n</div>\n"